import { render, staticRenderFns } from "./AboutUs_PT.vue?vue&type=template&id=3d91bb79&scoped=true&"
import script from "./AboutUs_PT.vue?vue&type=script&lang=js&"
export * from "./AboutUs_PT.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_PT.vue?vue&type=style&index=0&id=3d91bb79&prod&lang=css&"
import style1 from "./AboutUs_PT.vue?vue&type=style&index=1&id=3d91bb79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91bb79",
  null
  
)

export default component.exports